/**
 * Normalizes a coverage's `productType` for use as the `benefitPlanType` query
 * parameter on coverage-note endpoints.
 *
 * Coverage notes are partitioned by `(coverage_id, benefit_plan_type)` on the
 * backend, where legacy/general notes are stored with `benefit_plan_type = NULL`.
 * Only dental coverages need to disambiguate (PPO vs HMO); for every other
 * coverage type, `productType` is `notApplicable`, which is a distinct partition
 * from NULL and would hide pre-existing notes.
 *
 * Returns `undefined` for `notApplicable`, empty, or missing values so the
 * caller omits the query parameter and continues targeting the NULL partition.
 */
const NOT_APPLICABLE = "notApplicable";

export const normalizeNoteBenefitPlanType = (
  productType: string | undefined,
): string | undefined => {
  if (!productType || productType === NOT_APPLICABLE) {
    return undefined;
  }
  return productType;
};
